exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-menu--horizontal>.el-menu-item{float:left;height:50px;line-height:50px;margin:0;border-bottom:3px solid transparent;color:#999093;padding:0 5px;margin:0 10px}.el-menu--horizontal>.el-menu-item.is-active{border-bottom:3px solid var(--theme);color:#303133}.el-menu--horizontal>.el-submenu .el-submenu__title{height:50px !important;line-height:50px !important}\n", ""]);

// exports
